module.exports = __webpack_public_path__ + "media/shared/images/tolo_arrow_collapsed-3af103133b9c218482639bc7d1801c2d.svg";